import store from 'store';
import CryptoStorePlugin from './CryptoStore';

store.addPlugin(CryptoStorePlugin);
module.exports = store;